import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sevanseateronrentinpune() {



  const cardData = {
"keyword": "7 Seater on rent in Pune",

"headingDescription":
  "Shivai Travels offers reliable and comfortable 7 Seater on rent in Pune for family trips, airport transfers, corporate travel, outstation journeys, pilgrimage tours, and weekend getaways. Whether you need a spacious vehicle for city travel or long-distance road trips, our 7-seater cab service ensures a smooth, safe, and stress-free journey. With experienced drivers familiar with Pune city routes and highway driving, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel solution from Pune. Our fleet includes popular 7-seater options like Ertiga, Innova, and other comfortable MPVs suitable for small families and groups. With flexible booking options such as hourly, daily, one-way, and round-trip packages, doorstep pickup, easy reservation, and 24/7 customer support, Shivai Travels ensures a comfortable and budget-friendly travel experience.",

"topPlaces": [

  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal beach destination near Mumbai known for clean beaches, forts, and resorts, ideal for relaxed group travel from Pune."
  },
  {
    "title": "Konkan Beaches (Kashid, Murud, Diveagar)",
    "description":
      "Konkan beaches like Kashid, Murud Janjira, and Diveagar are popular weekend destinations for scenic coastal drives and beach outings from Pune."
  },
  {
    "title": "Pune City Tour",
    "description":
      "7-seater rentals are widely used for Pune city sightseeing covering Shaniwar Wada, Dagdusheth Temple, Aga Khan Palace, and other heritage attractions."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description":
      "Ajanta and Ellora Caves near Aurangabad are UNESCO World Heritage Sites often visited using 7-seater vehicles for comfortable long-distance travel."
  },
  {
    "title": "Goa Road Trip",
    "description":
      "Goa is one of the most popular long-distance destinations from Pune, and 7-seater cabs are commonly chosen for comfortable family and group road trips."
  },
    {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular hill stations near Pune known for waterfalls, valleys, caves, and scenic viewpoints, making them ideal for 7-seater family and group trips."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for strawberries, cool weather, and viewpoints, perfect for comfortable group travel from Pune in 7-seater vehicles."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, frequently visited by families using 7-seater cabs for comfortable darshan journeys."
  },
  {
    "title": "Nashik & Trimbakeshwar",
    "description":
      "Nashik is known for religious tourism, vineyards, and Trimbakeshwar Jyotirlinga, making it a popular outstation destination for 7-seater rentals from Pune."
  },
  {
    "title": "Western Ghats Scenic Route",
    "description":
      "The Pune highway routes pass through the Western Ghats offering greenery, ghats, tunnels, and scenic landscapes, making 7-seater travel enjoyable and comfortable."
  }
],



services: [
  {
    name: "7 Seater Car Rental Pune",
    description: "7 seater car rental Pune service provides reliable and spacious transportation for airport transfers, family trips, business travel, sightseeing tours, and outstation journeys. Comfortable 7 seater vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer comfortable seating, air conditioning, and luggage space suitable for family and group travel requirements. Flexible booking options allow convenient 7 seater car rental reservations in Pune."
  },
  {
    name: "Pune 7 Seater Cab Service",
    description: "Pune 7 seater cab service offers dependable transportation solutions for travelers within Pune and nearby destinations. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient 7 seater cab reservations."
  },
  {
    name: "7 Seater Taxi Hire Pune",
    description: "7 seater taxi hire Pune service provides affordable and comfortable travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and airport travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 7 seater taxi hire reservations."
  },
  {
    name: "Cheap 7 Seater Pune Rental",
    description: "Cheap 7 seater Pune rental service provides quality transportation for passengers seeking comfortable and economical group travel. Vehicles offer spacious interiors, luggage capacity, and smooth ride quality suitable for tourism, office travel, and personal journeys. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient budget 7 seater reservations."
  },
  {
    name: "7 Seater Outstation Pune Cab",
    description: "7 seater outstation Pune cab service offers economical and comfortable transportation for families, small groups, and tourists traveling from Pune to nearby destinations. Vehicles provide smooth highway travel suitable for one-day tours, airport transfers, and long-distance journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient outstation 7 seater reservations."
  },
  {
    name: "Family 7 Seater Pune Hire",
    description: "Family 7 seater Pune hire service provides comfortable transportation for families, corporate teams, and tourists traveling within Pune and outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, business travel, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient family 7 seater reservations."
  },
  {
    name: "Pune 7 Seater Booking Service",
    description: "Pune 7 seater booking service offers spacious and economical transportation for travelers planning family tours, sightseeing journeys, and long-distance travel. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for extended travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 7 seater booking reservations."
  },
  {
    name: "7 Seater SUV Rent Pune",
    description: "7 seater SUV rent Pune service provides reliable transportation for local and outstation travel requirements with spacious vehicles and professional drivers. Vehicles ensure smooth city and highway travel suitable for tourism, airport transfers, office travel, and family outings. Professional chauffeurs ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 7 seater SUV reservations."
  },
  {
    name: "7 Seater One Way Pune Cab",
    description: "7 seater one way Pune cab service offers comfortable transportation for one-side journeys from Pune to nearby cities and tourist destinations. Vehicles provide spacious seating and luggage space suitable for airport drops, business trips, tourism, and family travel. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-way 7 seater reservations."
  },
  {
    name: "7 Seater Round Trip Pune",
    description: "7 seater round trip Pune service offers reliable transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with return options. Vehicles provide comfortable seating and luggage space suitable for families, groups, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip 7 seater reservations."
  },
  {
    name: "Airport 7 Seater Pune Cab",
    description: "Airport 7 seater Pune cab service provides complete transportation solutions for airport pickup and drop requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, airport transfers, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient airport 7 seater cab reservations."
  },
  {
    name: "Best 7 Seater Rental Pune",
    description: "Best 7 seater rental Pune service offers comfortable and dependable transportation with experienced chauffeurs for local and outstation travel. Vehicles are suitable for business meetings, family trips, airport transfers, sightseeing tours, and personal travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient premium 7 seater rental reservations."
  },
  {
    name: "7 Seater Car with Driver Pune",
    description: "7 seater car with driver Pune service provides economical transportation for travelers looking for affordable SUV travel experiences with spacious seating and smooth ride quality. Vehicles are suitable for airport travel, office trips, sightseeing tours, and family outings. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 7 seater with driver reservations."
  },
  {
    name: "Pune Group 7 Seater Taxi",
    description: "Pune group 7 seater taxi service offers reliable and comfortable SUV transportation for local city rides, airport transfers, business travel, and outstation journeys. Vehicles provide spacious seating and smooth travel suitable for families, groups, and solo travelers. Professional drivers ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient group 7 seater taxi reservations."
  },
  {
    name: "Premium 7 Seater Pune",
    description: "Premium 7 seater Pune service provides spacious and dependable transportation for group outings, family tours, sightseeing trips, and outstation travel from Pune. Vehicles ensure comfortable seating, luggage space, and smooth highway travel suitable for long journeys and weekend trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium 7 seater reservations."
  }
],

tableData: [
  ["7 Seater Car Rental Pune", "Pune 7 Seater Cab Service"],
  ["7 Seater Taxi Hire Pune", "Cheap 7 Seater Pune Rental"],
  ["7 Seater Outstation Pune Cab", "Family 7 Seater Pune Hire"],
  ["Pune 7 Seater Booking Service", "7 Seater SUV Rent Pune"],
  ["7 Seater One Way Pune Cab", "7 Seater Round Trip Pune"],
  ["Airport 7 Seater Pune Cab", "Best 7 Seater Rental Pune"],
  ["7 Seater Car with Driver Pune", "Pune Group 7 Seater Taxi"],
  ["Premium 7 Seater Pune", "7 Seater Car Rental Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 7 Seater on Rent in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable 7 seater rental service in Pune with professional drivers, comfortable seating, and punctual pickup for smooth and safe travel experiences."
      },
      {
        WhyChooseheading: "Affordable 7 Seater Rental Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable 7 seater on rent in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 7 Seater Vehicle Availability",
        WhyChoosedescription: "Our 7 seater rental service in Pune operates 24 hours a day for airport transfers, family tours, corporate travel, weddings, outstation trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC 7 Seater Cars",
        WhyChoosedescription: "All 7 seater vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide comfortable local and long-distance travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Booking Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way 7 seater booking, round-trip travel, airport transfers, local sightseeing, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Ideal for Family & Group Travel",
        WhyChoosedescription: "Our 7 seater vehicles including Ertiga and Innova are ideal for families, tourists, wedding guests, and corporate travelers with spacious seating and luggage capacity."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for City & Highway Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, Konkan roads, hill stations, and interstate destinations, ensuring safe driving and smooth travel for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is 7 seater rental service in Pune?", answer: "7 seater rental service in Pune provides comfortable transportation for family trips, airport transfers, corporate travel, sightseeing tours, and outstation journeys." },
    { question: "Is 7 seater on rent in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 7 seater rental service in Pune." },
    { question: "Which 7 seater vehicles are available?", answer: "Shivai Travels offers Ertiga, Innova, and Innova Crysta 7 seater vehicles." },
    { question: "Can I book 7 seater vehicles for outstation travel?", answer: "Yes, customers can book 7 seater vehicles for local sightseeing, airport transfers, family tours, and outstation travel." },
    { question: "Do you provide one-way and round-trip 7 seater service?", answer: "Yes, Shivai Travels provides both one-way and round-trip 7 seater booking services." },
    { question: "Are all 7 seater vehicles air-conditioned?", answer: "Yes, all 7 seater vehicles are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book 7 seater on rent in Pune online?", answer: "Yes, customers can easily book 7 seater rental service online or through phone booking." },
    { question: "Do you provide 7 seater vehicles for weddings and airport transfers?", answer: "Yes, Shivai Travels provides 7 seater vehicles for weddings, airport transfers, family trips, and corporate transportation." },
    { question: "Are 7 seater rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 7 seater rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Patil",
      feedback:
        "Booked 7 seater on rent in Pune with Shivai Travels. Comfortable vehicle, smooth journey, and excellent driver support for our family trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent 7 seater rental service in Pune. Affordable pricing, clean vehicle, and wonderful travel experience.",
      rating: 5
    }
  ];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "7 Seater Car on Rent in Pune",
  "image": "https://shivaitravels.com/assets/images/7-seater-pune.jpg",
  "description": "Book 7 seater car on rent in Pune for family trips, airport transfers, and outstation travel. Shivai Travels offers spacious SUV and MPV options with professional drivers, affordable pricing, and reliable service for group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shivaitravels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹14/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/7-seater-on-rent-in-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>7 Seater Car on Rent in Pune | Family Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book 7 seater car on rent in Pune for family travel, airport transfers, and outstation trips. Comfortable SUV taxi service with driver at affordable prices for group travel."
  />

  <meta
    name="keywords"
    content="7 seater car rental pune, pune 7 seater cab service, 7 seater taxi hire pune, cheap 7 seater pune rental, 7 seater outstation pune cab, family 7 seater pune hire, pune 7 seater booking service, 7 seater suv rent pune, 7 seater one way pune cab, 7 seater round trip pune, airport 7 seater pune cab, best 7 seater rental pune, 7 seater car with driver pune, pune group 7 seater taxi, premium 7 seater pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sevanseateronrentinpune;